export default __webpack_public_path__ + "ad81635c44f80173632737c2f2d6f54d.svg";